<template>

  <Choose
    :test_work_queue_id="$props.test_work_queue_id"
    :test_work_queue_phase_id="$props.test_work_queue_phase_id"
    :test_id="$props.test_id"
    :internal_phase_id="$props.internal_phase_id"
    :prescription_test_id="$route.query.prescription_test_id"
    :state_slug="$props.state_slug"
    :laboratory_list_row_id="$props.laboratory_list_row_id"
    :title="'Cambio prova'"
    :prescription="$props.prescription"
    :subtitle="'Selezionare la prova al quale assegnare il lavoro'" />

</template>

<script>
import { useRoute } from "vue-router";
import Choose from "@/components/Iso-in/Choose";

export default {
  name: "IsoInChangedTest",
  inheritAttrs: false,
  props: [
    'test_work_queue_id',
    'test_work_queue_phase_id',
    'test_id',
    'internal_phase_id',
    'state_slug',
    'laboratory_list_row_id',
    'prescription',
  ],
  components: {
    Choose,
  },
  setup(props) {
    const route = useRoute();

    console.log("page: iso in changed test");
    console.log(`state_slug: ${props.state_slug}`);
    console.log(`test_work_queue_id: ${props.test_work_queue_id}`);
    console.log(`test_work_queue_phase_id: ${props.test_work_queue_phase_id}`);
    console.log(`internal_phase_id: ${props.internal_phase_id}`);
    console.log(`prescription_test_id: ${route.query.prescription_test_id}`);
    console.log(`laboratory_list_row_id: ${props.laboratory_list_row_id}`);
  }
}
</script>

